import { ApiConfig, handleResponse } from './config';
import type { Message, ConversationSummary } from '../../types/messaging';

export class MessageService {
  constructor(private config: ApiConfig) {}

  private getAuthHeaders(): Record<string, string> {
    const headers = { ...this.config.headers };
    if (typeof window !== 'undefined') {
      try {
        const authStorage = JSON.parse(localStorage.getItem('auth-storage') || '{}');
        const token = authStorage.state?.token;
        if (token && token !== 'null' && token !== 'undefined' && token !== '') {
          headers.Authorization = `Bearer ${token}`;
        }
      } catch {
        // Keep existing headers
      }
    }
    return headers;
  }

  async getConversations(): Promise<ConversationSummary[]> {
    const response = await fetch(`${this.config.baseUrl}/messages/conversations`, {
      headers: this.getAuthHeaders()
    });
    return handleResponse(response);
  }

  async getUnreadCount(): Promise<number> {
    const response = await fetch(`${this.config.baseUrl}/messages/unread-count`, {
      headers: this.getAuthHeaders()
    });
    const data = await handleResponse<{ count: number }>(response);
    return data.count;
  }

  async getMessages(conversationId: string): Promise<Message[]> {
    const response = await fetch(`${this.config.baseUrl}/messages/${conversationId}`, {
      headers: this.getAuthHeaders()
    });
    return handleResponse(response);
  }

  async sendMessage(recipientId: string, content: string): Promise<Message> {
    const response = await fetch(`${this.config.baseUrl}/messages`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ recipientId, content })
    });
    return handleResponse(response);
  }

  async markAsRead(conversationId: string): Promise<void> {
    const response = await fetch(`${this.config.baseUrl}/messages/${conversationId}/read`, {
      method: 'PUT',
      headers: this.getAuthHeaders()
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.message || 'Failed to mark messages as read');
    }
  }
}
